import { trimUptoTwoDecimals } from '@Pages/RetroSynthesis/utils';
import { buildStepsDataFromRouteLayout } from './stepsDataBuilder';

export const buildTableFromList = (routeLayout) => {
  const mapperFunc = (stepObj, item, children) => {
    const { confidence } = stepObj;
    const { substance } = item;
    return {
      ...stepObj,
      ...(confidence && {
        confidence: trimUptoTwoDecimals(confidence),
      }),
      substance,
      startingMaterials: children && children.reduce((memo, { substance }) => [ ...memo, substance ], []),
    }
  };

  return buildStepsDataFromRouteLayout(routeLayout, mapperFunc);
}
